<template>
  <svg
    :width="width ? width : height ? height : 41"
    :height="height ? height : width ? width : 41"
    viewBox="0 0 41 41"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Reiseplanlegger"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Evt-forside"
        transform="translate(-1336.000000, -147.000000)"
      >
        <g
          id="Group"
          transform="translate(1336.000000, 146.707049)"
        >
          <circle
            id="Oval"
            :fill="fillColor"
            cx="20.7516519"
            cy="20.6481778"
            r="20"
          ></circle>
          <path
            d="M28.4659376,18.7196064 L22.6802233,18.7196064 L22.6802233,12.9338921 C22.6802233,12.2239368 22.1044644,11.6481778 21.394509,11.6481778 L20.1087947,11.6481778 C19.3988394,11.6481778 18.8230804,12.2239368 18.8230804,12.9338921 L18.8230804,18.7196064 L13.0373662,18.7196064 C12.3274108,18.7196064 11.7516519,19.2953653 11.7516519,20.0053207 L11.7516519,21.291035 C11.7516519,22.0009903 12.3274108,22.5767493 13.0373662,22.5767493 L18.8230804,22.5767493 L18.8230804,28.3624636 C18.8230804,29.0724189 19.3988394,29.6481778 20.1087947,29.6481778 L21.394509,29.6481778 C22.1044644,29.6481778 22.6802233,29.0724189 22.6802233,28.3624636 L22.6802233,22.5767493 L28.4659376,22.5767493 C29.1758929,22.5767493 29.7516519,22.0009903 29.7516519,21.291035 L29.7516519,20.0053207 C29.7516519,19.2953653 29.1758929,18.7196064 28.4659376,18.7196064 Z"
            id="Path"
            :fill="strokeColor"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'filled-circle-plus',
  props: {
    fillColor: {
      type: String,
      default: '#0F1C70',
    },
    strokeColor: {
      type: String,
      default: '#FFFFFF',
    },
    height: {
      type: Number,
      required: false,
    },
    width: {
      type: Number,
      required: false,
    },
  },
};
</script>
